export const IMPLEMENTATION = {
  value: "IMPLEMENTATION",
  key: "status.implementation",
};
export const ACTIVE = {
  value: "ACTIVE",
  key: "status.active",
};
export const INACTIVE = {
  value: "INACTIVE",
  key: "status.inactive",
};
export const ARCHIVED = {
  value: "ARCHIVED",
  key: "status.archived",
};

export default [IMPLEMENTATION, ACTIVE, ARCHIVED];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/enums/clientCoveragesStatusTypes.js